import React, { Component } from 'react';
import data from "../../data/mainData.json";


class Social extends Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';

        return (
            <div className="ltn__social-media">
                <ul>
                    {data.header?.socialLinks.map((item, index) => (
                        <li key={index}>
                            <a href={item.link} title={item.title} target="_blank" rel="noopener noreferrer">
                                <i className={item.icon} />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default Social;
